import React from 'react';
import { Flex, Heading, Text, Image } from 'rebass';
import styled from 'styled-components';
import Link from 'components/Link';
import SkillBox from 'components/SkillBox';
import Candidate from 'types/candidates';
import colors from 'theme/colors';
import pendingIcon from 'assets/icons/pending.png';

const JobPostWrapper = styled(Flex)`
  border: 1px solid ${colors.primary};
`;

interface CandidatePostProps {
  candidate: Candidate;
}

const PendingCandidatePost: React.FC<CandidatePostProps> = ({ candidate }): JSX.Element => {
  const { id, jobTitle, firstName, lastName, status, summary, salary, skills } = candidate;
  return (
    <JobPostWrapper width="calc(50% - 30px)" px={1} flexDirection="column" mb={6}>
      <Flex flexDirection="column" py={3} px={1}>
        <Heading as="h2" fontSize={['24px']} fontWeight={6}>
          {jobTitle}
        </Heading>
        <Flex width="100%" alignItems="center" justifyContent="space-between" mb={2}>
          <Heading as="h2" fontSize={['24px']} fontWeight={6}>
            {firstName} {lastName}
          </Heading>
          <Image src={pendingIcon} />
        </Flex>
        <Text as="p" fontSize={['16px']} fontWeight={5} mb={1}>
          {`Status: ${status}`}
        </Text>
        <Text as="p" fontSize={['16px']} mb={1}>
          {salary ? `Desired: ${salary}` : 'Desired: zero'}
        </Text>
        <Text as="p" fontSize={['16px']} mb={1}>
          {summary}
        </Text>
      </Flex>
      <Flex>
        {skills &&
          skills.map((skill: string) => (
            <SkillBox key={skill} mr={1} py={1} px={2}>
              {skill}
            </SkillBox>
          ))}
      </Flex>
      <Flex justifyContent="center" py={2}>
        <Link
          to={`/review-pending-candidate/${id}`}
          color={colors.turquoise}
          hover={colors.turquoise}
          css="font-weight: 500;"
        >
          View details
        </Link>
      </Flex>
    </JobPostWrapper>
  );
};

export default PendingCandidatePost;
